import * as React from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import Shedule from "./Schedule.tsx";
import { getGroupSchedule } from "./studentAPI.ts";

interface IStudentSchedule {
  state: boolean;
  setModalState: any;
}

const FacultyList = {
  202: "ФАЯ",
  196: "ФРЯ",
  222: "ФРЯ",
  221: "ФКЯиК",
  203: "ПФ",
  193: "ФМК",
  217: "Магистратура",
};

const StudyFormList = {
  1: "Дневная",
  2: "Заочная",
};

const GradeList = [1, 2, 3, 4, 5];
export default function StudentSchedule({
  state,
  setModalState,
}: IStudentSchedule) {
  React.useEffect(() => {
    if (state) {
      console.log("Student");
    } else {
      SetFaculty("Факультет");
      SetStudyForm("Форма Обучения");
      SetGrade("Курс");
      console.log("Student Reset");
    }
  }, [state]);
  const [Faculty, SetFaculty] = React.useState("Факультет");
  const [StudyForm, SetStudyForm] = React.useState("Форма Обучения");
  const [Grade, SetGrade] = React.useState("Курс");

  return (
    <Shedule
      state={state}
      setScheduleState={setModalState}
      addButton={() =>
        getGroupSchedule({
          groupId: 224003618,
          weekType: "fourthWeek",
        })
      }
    >
      <Menu as="div" className="relative inline-block text-left">
        <MenuButton
          aria-required={true}
          className="inline-flex w-40 justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
        >
          {Faculty}
          <ChevronDownIcon
            aria-hidden="true"
            className="-mr-1 h-5 w-5 text-gray-400"
          />
        </MenuButton>

        <MenuItems
          transition
          className="absolute right-0 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
        >
          {Object.values(FacultyList).map((faculty, index) => {
            return (
              <MenuItem key={index}>
                <button
                  key={index}
                  onClick={() => {
                    SetFaculty(faculty);
                  }}
                  className="w-full h-full block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                >
                  {faculty}
                </button>
              </MenuItem>
            );
          })}
        </MenuItems>
      </Menu>

      <Menu as="div" className="relative inline-block text-left">
        <MenuButton
          aria-required={true}
          className="inline-flex w-40 justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
        >
          {StudyForm}
          <ChevronDownIcon
            aria-hidden="true"
            className="-mr-1 h-5 w-5 text-gray-400"
          />
        </MenuButton>

        <MenuItems
          transition
          className="absolute right-0 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
        >
          {Object.values(StudyFormList).map((type, index) => {
            return (
              <MenuItem key={index}>
                <button
                  key={index}
                  onClick={() => {
                    SetStudyForm(type);
                  }}
                  className="w-full h-full block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                >
                  {type}
                </button>
              </MenuItem>
            );
          })}
        </MenuItems>
      </Menu>

      <Menu as="div" className="relative inline-block text-left">
        <MenuButton
          aria-required={true}
          className="inline-flex w-40 justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
        >
          {Grade}
          <ChevronDownIcon
            aria-hidden="true"
            className="-mr-1 h-5 w-5 text-gray-400"
          />
        </MenuButton>

        <MenuItems
          transition
          className="absolute right-0 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
        >
          {GradeList.map((_, index) => {
            return (
              <MenuItem key={index}>
                <button
                  key={index}
                  onClick={() => {
                    SetGrade(String(index + 1));
                  }}
                  className="w-full h-full block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                >
                  {index + 1}
                </button>
              </MenuItem>
            );
          })}
        </MenuItems>
      </Menu>
    </Shedule>
  );
}
